import createAxios from './api'

const PATH = 'documents'

export default {
  async uploadDocument(fileName, file, source) {
    const axios = await createAxios()

    const params = {
      fileName: fileName.endsWith('.pdf') ? fileName : (fileName + '.pdf')
    }

    if (source != null) {
      params.source = source
    }

    const resp = await axios.post(`${PATH}`, file, {
      headers: {
        'Content-Type': 'application/pdf'
      },
      params: params
    })

    return resp.data
  },

  async uploadBatch(batchName, docs) {
    const form = new FormData()
    const encodeFileName = (file) => {
      return new File([file], encodeURIComponent(file.name), { type: file.type })
    }
    const encodedFiles = docs.map(file => encodeFileName(file))

    form.append('batchName', batchName || new Date().toUTCString())
    encodedFiles.forEach((f) => {
      form.append('files', f)
    })

    const axios = await createAxios()
    const resp = await axios.post(`${PATH}/batch`, form, {
      headers: {
        'Content-Type': 'multipart/form-data;boundary=boundary'
      }

    })

    return resp.data
  },

  async getBatch(id) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/batch/${id}`)

    return resp.data
  },

  async getThumbnail(id) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/${id}/thumbnail`, {
      headers: {
        Accept: 'application/octet-stream'
      },
      responseType: 'blob'
    })

    return resp.data
  },

  async getDocument(id) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/${id}`)

    return resp.data
  },

  async downloadDocument(id, downloadMode = 'ORIGINAL') {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/${id}/file`, {
      headers: {
        Accept: 'application/octet-stream'
      },
      params: { mode: downloadMode },
      responseType: 'blob'
    })

    return resp.data
  },

  async deleteDocument(id) {
    const axios = await createAxios()
    await axios.delete(`${PATH}/${id}`)
  }
}
